export default __webpack_public_path__ + "static/media/estenometro2.1219646b.png";